<template>
  <div>
    <section>
      <ul
        class="policy-list"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loading"
        infinite-scroll-distance="20"
      >
        <li v-for="item in newsList" :key="item.Id">
          <router-link :to="{name: 'news-detail',params: {id:item.ID}}">
            <h5>{{item.ContentTitle}}</h5>
            <div class="clearfix">
              <span class="fl">时间：{{item.CreatedTime}}</span>
            </div>
          </router-link>
        </li>
      </ul>
    </section>
    <Empty v-if="isEmpty"></Empty>
    <div class="status-hint" v-show="pageHint">{{pageHint}}</div>
    <footer-logo></footer-logo>
  </div>
</template>

<script>
import footerLogo from '@/components/footerLogo.vue'
import Empty from '@/views/statePage/empty.vue'
export default {
  components: {
    Empty,
    'footer-logo': footerLogo
  },
  data() {
    return {
      pageHint: '',
      isEmpty: false,
      loading: false,
      newsList: [],
      newsData: {
        title: '',
        type: 'EntPolicy',
        pageIndex: 1,
        pageSize: 20
      },
      totalPage: -1
    }
  },
  created() {
    this.getNewsList()
  },
  methods: {
    getNewsList() {
      var _this = this
      this.newsData.pageIndex = 1
      this.$fetch('/api/News/GetNewsList', this.newsData).then(result => {
        _this.totalPage = result.PageCount
        if (this.newsData.pageIndex >= this.totalPage) {
          this.pageHint = '没有更多了'
        } else {
          this.pageHint = '下拉加載更多...'
        }

        if (result.Items && result.Items.length > 0) {
          this.newsList = result.Items
          this.isEmpty = false
        } else {
          this.isEmpty = true
          this.pageHint = ''
        }
      })
    },
    loadMore() {
      if (this.newsData.pageIndex >= this.totalPage) {
        this.loading = false
      } else {
        this.loading = true
        this.pageHint = '加载中...'
        setTimeout(() => {
          this.newsData.pageIndex++
          this.$fetch('/api/News/GetNewsList', this.newsData).then(result => {
            this.newsList = this.newsList.concat(result.Items)
            this.totalPage = result.PageCount
            if (this.newsData.pageIndex >= this.totalPage) {
              this.pageHint = '没有更多了'
            }
            this.loading = false
          })
        }, 1500)
      }
    }
  }
}
</script>

<style lang="less" scoped>
section {
  width: 100%;
  background: #fff;
  border-bottom: 20 / @rem-size solid #f7f7f7;

  .policy-list {
    padding: 0 24 / @rem-size;

    li {
      padding: 15 / @rem-size 0;
      border-bottom: 1px solid #e5e5e5;

      &:last-child {
        border: 0 !important;
      }
    }

    h5 {
      font-size: 0.3rem;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      font-weight: 500;
      line-height: 46 / @rem-size;
      max-height: 92 / @rem-size;
      padding-left: 20 / @rem-size;
      position: relative;

      &::after {
        display: block;
        content: '';
        width: 8 / @rem-size;
        height: 8 / @rem-size;
        background: #005fd5;
        position: absolute;
        top: 15 / @rem-size;
        left: 0;
      }
    }

    span {
      font-size: 28 / @rem-size;
      color: #999;
      display: block;
      margin-top: 10 / @rem-size;
      padding-left: 20 / @rem-size;
    }
  }
}
</style>
